<script setup lang="ts">
import useFavorite from "@composables/favorite/useFavorite";

const {
  addFavorite,
  removeFavorite,
  isFavorite,
} = useFavorite();

interface GameData {
  id: number;
}

const props = defineProps({
  game: Object as PropType<GameData | any>,
  icon: {
    type: String,
    default: 'star',
  },
});

const rotating = ref(false);

const toggleFavorite = async () => {
  if (props.game == null) return;

  if (isFavorite(props.game.id) == false) {
    await animated();

    await addFavorite(props.game)
      .then(() => {
        rotating.value = false;
      })
      .finally(() => {
        rotating.value = false;
      });

    rotating.value = false;
  } else {
    await animated();

    await removeFavorite(props.game)
      .then(() => {
        rotating.value = false;
      })
      .finally(() => {
        rotating.value = false;
      });

    rotating.value = false;
  }
};

const animated = (time = 1000) => {
   rotating.value = true;
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};
</script>

<template>
  <div @click="toggleFavorite" :class="{'animate-jump animate-infinite animate-ease-in-out': rotating}">
    <template v-if="icon === 'star'">
      <svg v-if="isFavorite(props.game && props.game.id) == true" class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="1" viewBox="0 0 24 24">
        <path :class="{'animate-pulse animate-infinite animate-ease-in-out': rotating}"  class="transation duration-500 hover:animate-pulse stroke-brand-background fill-yellow-400" stroke-width="1.5" d="M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597l1.753-4.022Z"/>
      </svg>
      <svg v-if="isFavorite(props.game && props.game.id) == false" class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="1" viewBox="0 0 24 24">
        <path :class="{'animate-pulse animate-infinite animate-ease-in-out': rotating}" class="stroke-white hover:animate-pulse hover:stroke-yellow-400 fill-brand-background" stroke-width="1" d="M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597l1.753-4.022Z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'heart'">
      <svg v-if="isFavorite(props.game && props.game.id) == true" class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="red" viewBox="0 0 24 24">
        <path :class="{'animate-pulse animate-infinite animate-ease-in-out': rotating}" class="transition duration-500 hover:animate-pulse stroke-brand-background fill-red-500" stroke-width="1.5" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
      <svg v-if="isFavorite(props.game && props.game.id) == false" class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path :class="{'animate-pulse animate-infinite animate-ease-in-out': rotating}" class="stroke-white hover:animate-pulse hover:stroke-red-500 fill-brand-background" stroke-width="1" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    </template>
  </div>
</template>

<style scoped>
</style>